import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useMutation } from "react-query"
import { createCategory } from "~/actions/categories"
import CategoryCardList from "~/components/Categories/CategoriesCardList"
import AdminActionBar from "~/components/Common/AdminActionBar"
import AppContext from "~/contexts/App"
import CategoriesContext from "~/contexts/Categories"
import Page from "~/pages/Page"
import Router from "~/router"

const List = ({ routes = [], ...rest }) => {
  const createCategoriesMutation = useMutation(createCategory)

  const { openDialog, setPageTitle } = useContext(AppContext)

  const { categories, refetchCategories } = useContext(CategoriesContext)
  const [orderedCategories, setOrderedCategories] = useState()
  const [searchValue, setSearchValue] = useState("")

  useEffect(() => {
    if (categories) {
      setOrderedCategories(categories)
    }
  }, [categories])

  useEffect(() => {
    setPageTitle("Categories")
  }, [])

  const openCreateDialog = () => {
    let data = {
      title: "New Category",
      subtitle: "Create a new Category",
      type: "category",
      create: createCategoriesMutation,
      refetch: refetchCategories,
    }
    openDialog("createCategoryDialog", data)
  }

  return (
    <Page>
      <AdminActionBar
        buttonName="New Category"
        buttonFunc={openCreateDialog}
        sortOptions={[]}
        setSortState={() => {}}
        setFilterState={setSearchValue}
        placeholder="Search Categories"
      />
      <CategoryCardList
        categories={orderedCategories}
        setOrderedCategories={setOrderedCategories}
        openCreateDialog={openCreateDialog}
        searchValue={searchValue}
      />
      <Router routes={routes} {...rest} />
    </Page>
  )
}

List.propTypes = {
  routes: PropTypes.array,
}

export default List
